import { createReducer, on } from '@ngrx/store';
import { setProposal } from './proposal.actions';

export interface State {
  proposal; // Proposal; TODO: crear modelo de Proposal
}

export const initialState = JSON.parse(localStorage.getItem('currentProposal')) || {};

export const proposalReducer = createReducer(
  initialState,

  on(setProposal, (state, { proposal }) => ({ ...proposal }))
);
